import _omitBy from 'lodash/omitBy';
import _isNil from 'lodash/isNil';

/**
 * Filters out undefined and null values from the top level of an object.
 * Nested objects retain their undefined/null values.
 *
 * @param obj - The object to filter
 * @returns A new object with top-level undefined and null values removed
 *
 * @example
 * // Returns { name: 'John', age: 30, hobbies: { type: 'sports', name: null } }
 * filterShallowUndefinedObjectEntries({ name: 'John', age: 30, address: undefined, phone: null, hobbies: { type: 'sports', name: null } });
 */
const filterShallowUndefinedObjectEntries = (obj) => {
    return _omitBy(obj, _isNil);
};

export { filterShallowUndefinedObjectEntries };
//# sourceMappingURL=objectUtils.js.map
